import { useState } from "react";
import { type ApolloError } from "@apollo/client";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const useCreateRole = () => {
    const { t } = useTranslation("common", {
        keyPrefix: "create-role",
    });

    const [loading] = useState(false);
    const [error] = useState<ApolloError>();

    const schema = yup
        .object({
            role: yup.object().shape({
                name: yup.string().required().label(t("role-name")),
                permissions: yup
                    .array()
                    .of(yup.string())
                    .min(1)
                    .required()
                    .label(t("permissions")),
            }),
        })
        .required();

    const form = useForm<yup.InferType<typeof schema>>({
        resolver: yupResolver(schema),
        reValidateMode: "onChange",
        mode: "onChange",
    });

    return {
        form,
        loading,
        error,
    };
};
